<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <div class="search-area">
            <CRow>
                <CCol sm="10">
                    <input type="text" v-model="searchValue" placeholder="Search" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="modalDetail"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div :style="addMode==true&&'background-color: lightgray;opacity: 0.2'" class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Detail Data Kontak Erat</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalDetail = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div :style="addMode==true&&'background-color: lightgray;opacity: 0.2'" style="padding-bottom:40px;padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="8">
                        <CRow>
                            <CCol sm="3">
                                Nama
                            </CCol>
                            <CCol sm="9">
                                :  <span class="font-weight-bold">{{datasDetail.nama}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                NIP
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.nik}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                Nomor KTP
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.noKtp}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                Tanggal Lahir
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.tanggalLahir}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                Jabatan
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.jabatan}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                Nama Atasan
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.namaAtasan}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                Status
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.status}}</span>
                            </CCol>
                        </CRow>
                        <CRow class="mt-1">
                            <CCol sm="3">
                                Keluhan
                            </CCol>
                            <CCol sm="9">
                                :  <span>{{datasDetail.keluhan}}</span>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4">
                        <CButton @click="modalKeluhan = true, editKeluhan = datasDetail.keluhan" type="button" class="btn btn-search"><span v-if="datasDetail.keluhan == ''">Tambah</span><span v-if="datasDetail.keluhan != ''">Edit</span> Keluhan</CButton>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="8">Daftar Kontak Erat</CCol>
                    <CCol sm="4" class="text-right">
                        <CButton @click="modalKontak = true" type="button" class="btn btn-search">Tambah Kontak Erat</CButton>
                    </CCol>
                    <CCol v-if="kontak.length != 0" class="mt-1" sm="12">
                        <table class="table table-responsive w-100 table-bordered">
                            <thead>
                                <tr>
                                    <th style="width:25% !important">Nama</th>
                                    <th style="width:25% !important">Jabatan</th>
                                    <th style="width:25% !important">Nomor KTP</th>
                                    <th style="width:25% !important">Nama Atasan</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="showHistory(datas[sequenceUnix].unix, kontak[id].idPegawai)" style="cursor:pointer" title="Lihat Riwayat" v-for="(il, id) in kontak" :key="id">
                                    <td style="width:25% !important">
                                        <CRow>
                                            <CCol sm="12">
                                                {{il.nama}}
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="12">
                                                {{il.nik}}
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td style="width:25% !important">
                                        {{il.jabatan}}
                                    </td>
                                    <td style="width:25% !important">
                                        {{il.noKtp}}
                                    </td>
                                    <td style="width:25% !important">
                                        {{il.namaAtasan}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
                </CRow>
                <CRow class="mt-5">
                    <CCol sm="10"></CCol>
                    <CCol sm="2">
                        <CButton style="width: 100%!important" @click="modalDetail = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="modalKeluhan"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Form Keluhan</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalKeluhan = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-bottom:40px;padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Masukan Keluhan</label>
                        <textarea class="form-control" v-model="editKeluhan" placeholder="isi keluhan ..." />
                    </CCol>
                </CRow>
                <CRow class="mt-5" >
                    <CCol sm="7"></CCol>
                    <CCol sm="5">
                        <CButton style="width: 100%!important" @click="addKeluhan()" class="btn-cancel">Simpan</CButton>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="modalKontak"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Daftar Kontak Erat</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalKontak = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-bottom:40px;padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Peserta</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisiblePeserta()"
                                    @blur="toggleCloseVisiblePeserta()"
                                    v-model="queryPeserta"
                                    v-text="selectedItemPeserta ? selectedItemPeserta['text'] : ''"
                                    @keydown.up="upPeserta"
                                    @keydown.down="downPeserta"
                                    @keydown.enter="selectItemPeserta"
                                    placeholder="Pilih Peserta"
                            >
                            <div class="popovers" v-show="visiblePeserta">
                                <div class="options" v-if="matchesPeserta.length != 0 && queryPeserta.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPeserta"
                                        :key="index"
                                        :class="{ 'selected': (selectedPeserta == index)}"
                                        @click="itemClickedPeserta(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label v-if="sumPeserta.length != 0">Daftar Peserta</label><br/>
                        <CRow v-if="sumPeserta.length != 0">
                            <CCol sm="12" v-for="(li, id) in sumPeserta" :key="id">
                                <CRow>
                                    <CCol sm="1">-</CCol>
                                    <CCol sm="11">{{li.nama}}</CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow class="mt-5" >
                    <CCol sm="6"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="modalKontak = false" class="btn-cancel">Batal</CButton>
                    </CCol> 
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="addKontak()" class="btn-edit-submit">Simpan</CButton>
                    </CCol> 
                </CRow>
            </div>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="modalHistory"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Riwayat Kontak Erat</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalHistory = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-bottom:40px;padding-right:20px;padding-left:20px">
                <CRow class="mt-5 text-center">
                    <CCol sm="3"></CCol>
                    <CCol sm="6">
                        <ul class="StepProgress" v-if="dataHistory.length != 0">
                            <li class="StepProgress-item" v-for="(item, index) in dataHistory" :key="'dataHistory'+index" :class="[item.finish != 'Y' ? 'is-done' : '']">
                                <div :style="'color:'+item.color" class="font-weight-bold">{{item.status}}</div>
                                <div>
                                    by <span class="font-weight-bold">{{item.namaPegawai}}</span> at {{item.tanggal}}
                                </div>
                                <div><span class="font-weight-bold">Noted: </span>{{item.keterangan}}</div>
                            </li>
                        </ul>
                        <span v-if="dataHistory.length == 0">Riwayat tidak ditemukan</span>
                    </CCol>
                    <CCol sm="3"></CCol>
                </CRow>
                <CRow class="mt-5" >
                    <CCol sm="9"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="modalHistory = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tableHasilTes'
import {DataApi} from "../../../service/DataApi";
export default {
    components: {
        Tables,
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama Peserta', 'Jenis Tes', 'Tanggal Tes', 'Status', 'Kontak Erat', 'Action'],
            dataTd: [['nama', 'nik'], 'jenis', 'tanggalHasil', 'status', 'jumlahKontakErat', 'action'],
            styleTable: ['200px', '100px', '100px', '100px', '100px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,


            // pagination
            page: 1,
            size: 10,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            searchValue: '',
            
            // datas
            datas: [],
            datasDetail: [],

            //error
            errorMessage: '',
            modalDetail: false,
            sequenceUnix: '',
            unixKeluhan: '',
            unixKontak: '',
            modalKeluhan: false,
            modalKontak: false,

            // data peserta
            dataPeserta: [],
            titlePeserta:"Pilih Peserta",
            selectedItemPeserta: null,
            selectedPeserta: 0,
            queryPeserta: '',
            visiblePeserta: false,
            idPeserta: '',
            kontak: [],
            sumPeserta: [],

            addMode: false,
            flagSearch: false,

            modalHistory: false,
            dataHistory: []
        }
    },
    computed: {
    },
    watch: {
        page() {
            window.scroll({
                top:300,
                left: 0,
                behavior: 'smooth'
            });
        },
        goArea() {
            window.scroll({
                top:300,
                left: 0,
                behavior: 'smooth'
            });
        },
        modalDetail() {
            if(this.modalDetail == false) {
                this.datasDetail = []
                this.unixKeluhan = ''
                this.unixKontak = ''
                this.sequenceUnix = ''
                this.kontak = []
                this.sumPeserta = []
            }
        },
        modalKeluhan() {
            this.changeMode()
            if(this.modalKeluhan == false) {
                this.editKeluhan = ''
            }
        },
        modalHistory() {
            this.changeMode()
            if(this.modalHistory == false) {
                this.dataHistory = []
            }
        },
        modalKontak() {
            if(this.modalKontak == false) {
                this.sumPeserta = []
                let kontak = this.kontak
                var i 
                for(i=0;i<kontak.length;i++) {
                    let onPush = {
                        nama: kontak[i].nama,
                        id: kontak[i].idPegawai
                    }
                    this.sumPeserta.push(onPush)
                }
            }
            this.changeMode()
        },
        queryPeserta() {
            if(this.queryPeserta == '') {
                this.idPeserta = ''
            }
            this.getDataPeserta()
        },
        searchValue() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * GET DATA
         */
        showHistory(daftar, ids) {
            this.modalHistory = true
            this.$store.state.loadingScreen = true
            let payload = {
                idDaftar: daftar,
                idPegawai: ids
            }
            DataApi.post("rta/kontak/erat/history", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.dataHistory = response.data
                } else {
                    this.dataHistory = []
                }
                this.$store.state.loadingScreen = false
            })
        },
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kantor.toLowerCase() < b.kantor.toLowerCase()) {
                        return -1
                    }
                    if (a.kantor.toLowerCase() > b.kantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData(flags) {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let filter = this.searchValue
            let page = this.page

            let payload = {
                limit: limit,
                filter: filter,
                pageIn: page
            }
            DataApi.post("rta/hasil/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                    if(flags == '1') {
                        this.editData(this.sequenceUnix)
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData('null')
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData('null')
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchValue = ''
            this.flagSearch = true
            this.getData('null')
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        editData(value) {
            this.datasDetail = []
            this.$store.state.loadingScreen = true
            this.sequenceUnix = value
            let unix = this.datas[value].unix
            this.datasDetail = this.datas[value]
            this.unixKeluhan = this.datasDetail.unix
            this.unixKontak = this.datasDetail.unix
            let payload = {
                unix: unix
            }
            DataApi.post("rta/hasil/detail/lihat", payload)
            .then(res => {
                this.kontak = []
                this.sumPeserta = []
                let response = res.data
                if(response.success == true) {
                    let kontak = response.data
                    this.kontak = kontak
                    var i 
                    for(i=0;i<kontak.length;i++) {
                        let onPush = {
                            nama: kontak[i].nama,
                            id: kontak[i].idPegawai
                        }
                        this.sumPeserta.push(onPush)
                    }
                } else {
                    this.kontak = []
                }
                this.modalDetail = true
                this.$store.state.loadingScreen = false
            })
        },
        getDownload() {
            this.$store.state.loadingScreen = true
            let limit = this.totalRowDetail
            let page = 1

            let payload = {
                idKantor: this.idKantor,
                idPegawai: this.idPegawai,
                limit: limit,
                pageIn: page,
                status: '',
                tanggal: this.tanggalKantor,
                unixJadwal: this.filterJam.value
            }
            DataApi.post("rta/absen/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Daftar Peserta Tes ' + this.dataNamaKantor + ' Tanggal ' + this.tanggalKantor
                    let data = [
                        {
                            sheet: 'Peserta',
                            columns: [
                                { label: 'Nama Peserta', value: 'nama'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Nomor KTP', value: 'noKtp' },
                                { label: 'Tanggal Lahir', value: 'tanggalLahir' },
                                { label: 'Nama Atasan', value: 'namaAtasan' },
                                { label: 'Jam Pelaksanaan', value: 'jam' },
                                { label: 'Status', value: 'status' },
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        changeMode() {
            if(this.modalKeluhan == true || this.modalKontak == true || this.modalHistory == true) {
                this.addMode = true
            } else {
                this.addMode = false
            }
        },
        addKeluhan() {
            let payload = {
                unix: this.unixKeluhan,
                keluhan: this.editKeluhan
            }
            DataApi.post("rta/keluhan/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.modalKeluhan = false
                    this.getData('1')
                }
            })
        },
        addKontak() {
            let data = ''
            var i 
            for(i=0;i<this.sumPeserta.length;i++) {
                let ids = this.sumPeserta[i].id
                if(data == '') {
                    data = ids
                } else {
                    data += '%%' + ids
                }
            }
            let payload = {
                unixDaftar: this.unixKontak,
                kontakErat: data
            }
            DataApi.post("rta/kontakerat/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.modalKontak = false
                    this.getData('1')
                    this.$emit('change', '1')
                }
            })
        },
        /**
         * SEARCH PESERTA
         */
        getDataPeserta() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 4,
                nama: this.queryPeserta,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPeserta = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPeserta.push(onPush)
                }
            })
        },
        toggleVisiblePeserta() {
            this.visiblePeserta = true;
        },
        hidePeserta() {
            this.visiblePeserta = false;
        },
        toggleCloseVisiblePeserta() {
            setTimeout(this.hidePeserta, 1000);
        },
        itemClickedPeserta(index) {
            this.selectedPeserta = index;
            this.selectItemPeserta();
        },
        selectItemPeserta() {
            if (!this.matchesPeserta.length) {
            return;
            }
            this.selectedItemPeserta = this.matchesPeserta[this.selectedPeserta];
            this.visiblePeserta = false;
            this.queryPeserta = this.selectedItemPeserta.text
            this.idPeserta = this.selectedItemPeserta.value
            var i = 0
            let data = this.sumPeserta
            let onPush = ''
            if(data.length == 0) {
                onPush = {
                    nama: this.queryPeserta.split(" - ")[0],
                    id: this.idPeserta
                }
                this.sumPeserta.push(onPush)
                this.modalPeserta = false
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j].id == this.idPeserta) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    onPush = {
                        nama: this.queryPeserta.split(" - ")[0],
                        id: this.idPeserta
                    }
                    this.sumPeserta.push(onPush)
                    this.modalPeserta = false
                } else {
                    this.errPeserta = 'Data sudah ada pada list'
                }
            }
            this.queryPeserta = ''
            this.idPeserta = ''
            if (this.shouldReset) {
            this.queryPeserta = '';
            this.selectedPeserta = 0;
            }
        },
        upPeserta() {
            if (this.selectedPeserta == 0) {
            return;
            }
            this.selectedPeserta -= 1;
            this.scrollToItemPeserta();
        },
        downPeserta() {
            if (this.selectedPeserta >= this.matchesPeserta.length - 1) {
            return;
            }
            this.selectedPeserta += 1;
            this.scrollToItemPeserta();
        },
        scrollToItemPeserta() {
            this.$refs.optionsList.scrollTop = this.selectedPeserta * this.itemHeight;
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    },
    computed: {
        matchesPeserta() {
            if (this.queryPeserta == '') {
                return [];
            }
            return this.dataPeserta.filter((item) => item['text'].toLowerCase().includes(this.queryPeserta.toLowerCase()))
        },
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 80%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item.is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
</style>